// ── Arc geometry ──────────────────────────────────────────────────────────

/**
 * Arc geometry derived from the former SVG `<textPath>` paths, expressed
 * directly as center/radius/angles (radians, screen convention: 0=east, π/2=
 * south, increasing clockwise). Angles are tuned to visually match the
 * previous layout; the fitter centers the glyph sequence on the arc midpoint.
 */
export const DEG = Math.PI / 180
export const CENTER = { x: 64, y: 64 }

// former `rotate(-15 64 64)` on the top path
export const TOP_ROTATION_DEG = 15
export const TOP_RADIUS = 34.4707
// 270° − 15° = 255°
export const TOP_CENTER_DEG = (180 + 360) / 2 - TOP_ROTATION_DEG
export const TOP_SPAN_DEG = 180

// Bottom text center, derived from the former `startOffset="71"` on a full
// circle of length 2π·44.95 ≈ 282.43 (71/282.43 ≈ 25.15% → 90.5°), measured
// from the path start at 165° along the counter-clockwise (decreasing angle)
// direction → 165° − 90.5° ≈ 74.5°.
export const BOTTOM_RADIUS = 44.95
export const BOTTOM_CENTER_DEG = 74.5
// Generous symmetric span so the text fits naturally and fill-tracking
// spreads it to match the former `textLength` look.
export const BOTTOM_SPAN_DEG = 138

// ── Font configuration ────────────────────────────────────────────────────

export const FONT_FAMILY = '"BMDupletTXT", Helvetica, sans-serif'
export const FONT_WEIGHT = 700
export const MAX_FONT_SIZE = 14
export const MIN_FONT_SIZE = 11
export const MAX_TRACKING = 1.5

export const fontConfig = {
  fontFamily: FONT_FAMILY,
  fontWeight: FONT_WEIGHT,
  maxFontSize: MAX_FONT_SIZE,
  minFontSize: MIN_FONT_SIZE,
  maxTracking: MAX_TRACKING,
  fillStyle: 'currentColor',
}

// ── Rendering ──────────────────────────────────────────────────────────────

/** Backing-store side, in user-space units. Matches the SVG `viewBox`. */
export const VIEWBOX = 128

/** Safety cap on binary-search iterations in `fitTextToArc`. */
export const MAX_BINARY_SEARCH_ITERATIONS = 16
